import {
    Box,
    Button,
    Typography,
} from '@mui/material'
import FindIdealBG from '../../../assets/find-ideal/find_ideal_bg.png'
import { MOTORLOAN_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMHomeFindIdeal: React.FC = () => {

    const { t } = useTranslation()

    // 打开motorloan
    const goToMotorloan = () => {
        window.open(MOTORLOAN_LINK)
    }
    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                height: isTablet ? '500px' : '700px',
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${FindIdealBG})`,
            }}
        >
            <Box sx={{
                width: '550px'
            }}>
                <Typography fontWeight={700} fontSize={'48px'} color={'#141F39'} textAlign={'center'}>
                    {t('t72')}
                </Typography>

                <Typography paddingTop={'15px'} fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} textAlign={'center'}>
                    {t('t73')}
                </Typography>
            </Box>
            <Box>
            <Button onClick={goToMotorloan}
                variant='contained'
                fullWidth
                sx={{
                    borderRadius: '30px',
                    mt: 6,
                    bgcolor: '#FFC107',
                    color: '#141F39',
                    fontSize: '14px',
                    fontWeight: 700,
                    '&:hover': {
                        bgcolor: '#FFC107',
                    },
                    height: '60px',
                    textTransform: 'none',
                }}
                >
                {t('t74')}
            </Button>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeFindIdeal
